// 必要なコンポーネントやライブラリをインポート
import UserFrame from "../organisms/UserFrame"; // ユーザー用のフレームコンポーネント
import { Container, Box, Typography } from '@mui/material'; // Material-UIのコンテナ、ボックス、タイポグラフィコンポーネント

/** 
 * ユーザー情報テンプレートコンポーネント
 * ユーザー情報（Login IDと会社名）を表示するためのUIを提供
 */ 
const UserInfoTemplate = () => {

    return (
        // ユーザー専用フレームで全体をラップ
        <UserFrame title=''> {/* タイトルは空の状態 */}
            {/* コンテンツの最大幅を`sm`（スモールサイズ）に設定 */}
            <Container maxWidth='sm'>
                {/* ユーザー情報を表示するためのボックス */}
                <Box sx={{ height: '600px', width: '100%', padding: '20px' }}>
                    {/* Login ID表示 */}
                    <Typography>
                        LoginID
                    </Typography>
                    {/* Login IDを表示する読み取り専用の入力フィールド */}
                    <input readOnly type="text" size={50} value="sample@test.com"/>

                    {/* 会社名表示 */}
                    <Typography sx={{ paddingTop: '10px' }}>
                        Company Name
                    </Typography>
                    {/* 会社名を表示する読み取り専用の入力フィールド */}
                    <input readOnly type="text" size={50} value="○○株式会社"/>
                </Box>
            </Container>
        </UserFrame>
    )
}

// コンポーネントをエクスポート
export default UserInfoTemplate;
